import * as Events from '@core/events';
import { CoreEvents } from '@core';

export const handler = ({
  form,
  event,
  payload,
}: Pick<Events.TEventInformation<unknown>, 'form' | 'event' | 'payload'>) => {
  const mapperNextStepIndex = {
    [CoreEvents.NAVIGATE_STEP_BACK]: form.step.index - 1,
    [CoreEvents.NAVIGATE_STEP_FORWARD]: form.step.index + 1,
  };
  const steps = form.schema.components;

  let nextStepIndex = mapperNextStepIndex[event];

  const nextStep = () => {
    if (payload.constructor === Object) {
      return steps[mapperNextStepIndex[event]];
    } else if (typeof payload === 'string') {
      nextStepIndex = steps.findIndex((item) => item.name === payload);
      return steps.find((item) => item.name === payload);
    } else if (typeof payload === 'number') {
      nextStepIndex = payload;
      return steps[payload];
    }
  };

  const step = nextStep();

  if (!step) {
    form.step = {
      ...form.step,
      navigated: false,
    };
    return;
  }

  form.step = {
    ...form.step,
    numSteps: steps.length,
    navigated: !!step,
    index: step ? nextStepIndex : form.step.index,
    currentStepSchema: step ? step : form.step.currentStepSchema,
  };
};
